"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownIndicator = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_select_1 = require("react-select");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var theme_1 = require("../../../theme");
exports.DropdownIndicator = function (props) {
    var selectProps = props.selectProps;
    var menuIsOpen = selectProps.menuIsOpen;
    return (react_1.default.createElement(StyledReactSelectDropdownIndicator, tslib_1.__assign({}, props),
        react_1.default.createElement(StyledIcon, { "data-test-component-name": "select-dropdown-button", className: menuIsOpen ? 'icon--menu_up' : 'icon--menu_down' })));
};
exports.DropdownIndicator.displayName = 'FOS_ReactSelect_DropdownIndicator';
var StyledReactSelectDropdownIndicator = styled_components_1.default(react_select_1.components.DropdownIndicator)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  margin-right: 0.8rem;\n"], ["\n  margin-right: 0.8rem;\n"])));
var StyledIcon = styled_components_1.default.i(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  font-size: 1.8rem;\n  color: ", ";\n"], ["\n  font-size: 1.8rem;\n  color: ", ";\n"])), theme_1.theme.colors.NTDarkGrey[900]);
var templateObject_1, templateObject_2;
